import { getDataForChart } from '../../../utils/reactChartConfig'
import { CONSTRUCTS } from '../../../utils/constructs'
import { convert1to6ToPercent } from '../../../utils/statisticCalc'

/**
 * called by ResultsModule2.js
 * @param jtLabels, object, 'label' portion of the jsonText object from Redux
 * @param modNpoAnswers, object, latest NPO survey answers for current module
 * @param benchMod, object, benchmark of either this NPO category or of all NPOs
 * @param modResults, object, the latest results of the user's organization with respect to above benchmark (percentiles)
 * @param benchType, string, benchmark chartType, either 'cat' or 'all'
 * @param yearlyComp, object, containing all the info and data for a yearly comparison (or null)
 * @param chartType, string, either 'summary' (overall result) or the section name (not yet used)
 * @return object, the chart data for Module 2
 *
 * Note: for yearly comparison, we use the following variables slightly differently:
 * modNpoAnswers = benchmark, either for all NPOs ('all') or only the NPOs of the same category ('cat')
 * benchMod = last survey results
 * modResults = results of selected year's survey (or null)
 * benchType = always null
 */
export const getChartDataMod2 = (jtLabels, modNpoAnswers, benchMod, modResults, benchType, yearlyComp, chartType) => {
  if (yearlyComp) {
    modNpoAnswers = yearlyComp.benchmark
    benchMod = yearlyComp.lastSurveyResults
    modResults = yearlyComp.selectedSurveyResults
    benchType = null
  }
  let chartLabels, npoData, benchData, resultsData
  switch (chartType) {
    case 'summary':
      chartLabels = [  // the order here pertains only to the chart
        `${jtLabels[CONSTRUCTS.VISIONARY_LEADERSHIP.name] || 'Visionary Leadership'}`.toUpperCase(),
        `${jtLabels[CONSTRUCTS.SERVANT_LEADERSHIP.name] || 'Servant Leadership'}`.toUpperCase(),
      ]
      npoData = [
        modNpoAnswers?.MLQ.mean,
        modNpoAnswers?.SVL.mean,
      ]
      benchData = [
        benchMod?.MLQ.mean,
        benchMod?.SVL.mean,
      ]
      if (yearlyComp) resultsData = [
        modResults?.MLQ.percentile,
        modResults?.SVL.percentile,
      ]
      break
    default:
      console.error('No match found for chart chartType:', chartType)
  }

  return getDataForChart(jtLabels, chartLabels, npoData, benchData, resultsData, benchType, yearlyComp)
}
